import api from '../index'

let header = {}
export default {
    // 获取用户信息
    getUserInfo(params) {
        // return出去了一个promise
        return api.get('/user/current', params, header)
    },
    // 找回密码
    find(params) {
        return api.put('/user/findPwd', params, header)
    },
    // 修改密码
    edit(params,header={}) {
        return api.post('/user/editPwd', params, header)
    },
    // 注销
    logout() {
        // return api.delete('/oauth/logout', params, header)
        return api.post('/oauth/logout', {}, header)
    },
    getThemeSkin(){
      // header={
      //  'Authorization':'bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJkZXB0TmFtZSI6IuinhumikemDqCIsImNvbG9yRmxhZyI6NCwidXNlcl9uYW1lIjoiMTk5NjYyNTY2NTYiLCJ1c2VySWQiOiJhMDI4N2M5OTk5YTg0YjQ1OTU2MWY0MDE3M2ViOGZmNCIsImNsaWVudF9pZCI6ImFkbWluIiwiZHV0eU5hbWUiOm51bGwsImF1ZCI6WyJhZG1pbiIsImNsaWVudCJdLCJzY29wZSI6WyJhbGwiXSwibmlja25hbWUiOiLmhZXlrrnovbvpl7IiLCJ1c2VyVHlwZSI6MiwiZXhwIjoxNzA3MDUxNjAyLCJqdGkiOiJZV1NvbHZBX2x6UXdXOEk4SFc1di1POW9KbWsiLCJ1c2VybmFtZSI6IjE5OTY2MjU2NjU2In0.e3OM2GFU8g2pjKHw0osYJbvxK9I9gANBwAGCojoWOIxNnki_ZQYPtCixYtfyQTrefQ5kk7YZeBUb0KroSPUWOASeI-tqnkwBSObLq5l0IyqBamZCYyeTX32Dpk0trrTKXYbuuRXkNGN1vqntFGBwM6o_us2B0bIK-o9Dd6sGQ67TO9_2kssBlm6mNGYNotVQYrxZ9qtljYNtP5ixpBwfyqwIfkYwlGmg53qy8Y5ioI1cqpmkUQGt65tYQe56qoQVwoIVAdCLhFOSv1TPlq5WYIS-UA_-DNyAyjPOSu8kg73QDfNSrPcUN4ZzCqzVyYAemQ2ZsHi7jY6L0s97Ac2t1g',
      //  'eid':'eid_1be6eb29d0404360be776e007435699e'
      // }
      let header = {
        belong: 'bulletin'
      }
      return api.get('/theme', {}, header)
      
    }

    
}
